import bdServicesExt from '../bd-servicesExt'
import bdServices from '../bd-services'
import bdServices125 from '../bd-services125'
import 'regenerator-runtime'

var FormData = require('form-data')
const currentUrl = window.location.hostname

const InventarioServices = {}

InventarioServices.getAltas = function () {
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get('/servidores/inventario/getAltas.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/servidores/inventario/getAltas.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

InventarioServices.getTipos = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getTipos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getTipos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getCategorias = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getCategorias.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getCategorias.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTags = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getTags.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getTags.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getMarcas = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getMarcas.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getMarcas.php')
      .then(res => res)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addBaseArticulo = async function (idcat, categoria, idsub, subcategoria, marca, modelo, codigo) {
  let formData = new FormData()
  formData.append('idcat', idcat)
  formData.append('categoria', categoria)
  formData.append('idsub', idsub)
  formData.append('subcategoria', subcategoria)
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('codigo', codigo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addBaseArticulo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addCategoria = async function (id, nombre, area, servicio, consumible, tipo, catResp) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)
  formData.append('area', area)
  formData.append('servicio', servicio)
  formData.append('consumible', consumible)
  formData.append('tipo', tipo)
  formData.append('catResp', catResp)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addCategoria.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addMarca = async function (id, nombre) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addMarca.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteCategoria = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteCategoria.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteMarca = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteMarca.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getSubcategorias = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getSubCategorias.php'
  }
  const data = await bdServices(options)
    .then(res => res)
    .catch(e => console.log(e))
  return data
}

InventarioServices.addSubcategorias = async function (id, nombre, idCategoria) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)
  formData.append('idCategoria', idCategoria)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addSubCategoria.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.editSubcategoria = async function (id, nombre) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editSubCategoria.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.editmarca = async function (id, nombre) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editMarca.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data

  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data

  }
}

InventarioServices.getCats_Subcats = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getCats_Subcats.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getCats_Subcats.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getBancos = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getBancos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getBancos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getMunicipios = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/requisiciones/getMunicipios.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/requisiciones/getMunicipios.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getBaseArticulos = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get('/servidores/inventario/getBaseArticulos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get('/servidores/inventario/getBaseArticulos.php')
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getCats_SubcatsInd = async function (idCat) {
  let formData = new FormData()
  formData.append('idCat', idCat)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getCats_SubcatsInd.php.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}


//Arículos

InventarioServices.addArticulo = async function (id, id_Alta, serie, marca, modelo, observaciones, idCategoria,
  categoria, idSubcategoria, subcategoria, idArtBase, fechaReg, ubicacion, oficina, ordenCompra, estado,
  idIngresa, ingresa, idResguardo, resguardo, ultimoMov, fechaCompra, finishGarantia, garantia, moneda,
  precioUnitario, cajaChica, tag, partida, noParte, localizacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('id_Alta', id_Alta)
  formData.append('serie', serie)
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('observaciones', observaciones)
  formData.append('idCategoria', idCategoria)
  formData.append('categoria', categoria)
  formData.append('idSubcategoria', idSubcategoria)
  formData.append('subcategoria', subcategoria)
  formData.append('idArtBase', idArtBase)
  formData.append('fechaReg', fechaReg)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)
  formData.append('ordenCompra', ordenCompra)
  formData.append('estado', estado)
  formData.append('idIngresa', idIngresa)
  formData.append('ingresa', ingresa)
  formData.append('idResguardo', idResguardo)
  formData.append('resguardo', resguardo)
  formData.append('ultimoMov', ultimoMov)
  formData.append('fechaCompra', fechaCompra)
  formData.append('finishGarantia', finishGarantia)
  formData.append('garantia', garantia)
  formData.append('moneda', moneda)
  formData.append('precioUnitario', precioUnitario)
  formData.append('cajaChica', cajaChica)
  formData.append('tag', tag)
  formData.append('partida', partida)
  formData.append('noParte', noParte)
  formData.append('localizacion', localizacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addArticulo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addConsumible = async function (marca, modelo, area, linea, detalle, idCategoria,
  categoria, idSubcategoria, subcategoria, unidadMedida, limite, noParte) {
  let formData = new FormData()
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('area', area)
  formData.append('linea', linea)
  formData.append('detalle', detalle)
  formData.append('idCategoria', idCategoria)
  formData.append('categoria', categoria)
  formData.append('idSubcategoria', idSubcategoria)
  formData.append('subcategoria', subcategoria)
  formData.append('unidadMedida', unidadMedida)
  formData.append('limite', limite)
  formData.append('noParte', noParte)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addConsumible.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.add_consumible_add = async function (fechaAlta, idconsumible, cantidad, precioU, oficina,
  ordenCompra, fechaCompra, factura, idProveedor, idIngresa, ingresa, idResguardo, resguardo, cajaChica,
  localizacion, partida, moneda) {
  let formData = new FormData()
  formData.append('fechaAlta', fechaAlta)
  formData.append('idconsumible', idconsumible)
  formData.append('cantidad', cantidad)
  formData.append('precioU', precioU)
  formData.append('oficina', oficina)
  formData.append('ordenCompra', ordenCompra)
  formData.append('fechaCompra', fechaCompra)
  formData.append('factura', factura)
  formData.append('idProveedor', idProveedor)
  formData.append('idIngresa', idIngresa)
  formData.append('ingresa', ingresa)
  formData.append('idResguardo', idResguardo)
  formData.append('resguardo', resguardo)
  formData.append('cajaChica', cajaChica)
  formData.append('localizacion', localizacion)
  formData.append('partida', partida)
  formData.append('moneda', moneda)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_add.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.add_consumible_salida = async function (id, idconsumible, cantidad, fechaReg, ubicacion, oficina, idEntrega, entrega, idRecibe, recibe) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idc', idconsumible)
  formData.append('c', cantidad)
  formData.append('fR', fechaReg)
  formData.append('u', ubicacion)
  formData.append('o', oficina)
  formData.append('iE', idEntrega)
  formData.append('e', entrega)
  formData.append('iR', idRecibe)
  formData.append('r', recibe)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.add_consumible_movs = async function (idconsumible, fechaReg, cantidad, idmov, oficina, idIngresa, ingresa, idResguardo, resguardo, tipo) {
  let formData = new FormData()
  formData.append('idconsumible', idconsumible)
  formData.append('fechaReg', fechaReg)
  formData.append('cantidad', cantidad)
  formData.append('idmov', idmov)
  formData.append('oficina', oficina)
  formData.append('idIngresa', idIngresa)
  formData.append('ingresa', ingresa)
  formData.append('idResguardo', idResguardo)
  formData.append('resguardo', resguardo)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_movs.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateConsumible_Cant = function (id, cant) {
  let formData = new FormData()
  formData.append('i', id)
  formData.append('c', cant)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/update_cantConsumibles.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

InventarioServices.getConsumibles_Tras = async function (idconsumible, ubicacion) {
  let formData = new FormData()
  formData.append('ic', idconsumible)
  formData.append('ubi', ubicacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getConsumibles_Tras.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getConsumibles_In = async function (idconsumible, ubicacion) {
  let formData = new FormData()
  formData.append('ic', idconsumible)
  formData.append('ubi', ubicacion)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getConsumibles_In.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getConsumibles_Out = async function (idconsumible, ubicacion) {
  let formData = new FormData()
  formData.append('ic', idconsumible)
  formData.append('ubi', ubicacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getConsumibles_Out.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getConsumibles_Asign = async function (idconsumible, ubicacion) {
  const data = await bdServices.get(`/servidores/inventario/getConsumibles_Asign.php?ic=${idconsumible}&ubi=${ubicacion}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosAlmacenGIA = async function (ubicacion) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulos_Almacen.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulos_Almacen.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArticulosAlmacenArea = async function (area) {
  const data = await bdServices.get(`/servidores/inventario/getArticulosAlmacenArea.php?a=${area}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosAlmacenSubArea = async function (area) {
  const data = await bdServices.get(`/servidores/inventario/getArticulosAlmacenSubArea.php?a=${area}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosAlmacen = async function (u) {
  const data = await bdServices.get(`/servidores/inventario/getArticulosAlmacen.php?u=${u}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulos_Ubicacion = async function (ubi) {
  let formData = new FormData()
  formData.append('u', ubi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getArticulosUbicacion'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosAlmacenCede = async function (ubicacion) {
  const data = await bdServices.get(`/servidores/inventario/getArticulos_AlmacenCede.php?u=${ubicacion}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosUbicacion = async function (ubicacion) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulos_ubicacion.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulos_ubicacion.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArticulosCede = async function (ubicacion) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulos_cede.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulos_cede.php?u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArticulos_Items = async function (id, ubicacion) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulos_Items.php?id=${id}&u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulos_Items.php?id=${id}&u=${ubicacion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArticulos = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulos.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulos.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArticulosCompras = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulosCompras.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulosCompras.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.updateRequisicionItem = async function (idReqItem, idArticulo) {
  let formData = new FormData()
  formData.append('i', idReqItem)
  formData.append('ia', idArticulo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/updateRequisicionItem.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

InventarioServices.getConsumibles = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getConsumibles.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getConsumibles.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getBaseConsumibles = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getBaseConsumibles.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getBaseConsumibles.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getConsumiblesAlmacen = async function (ubi) {
  let formData = new FormData()
  formData.append('ubi', ubi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getConsumiblesAlmacen.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosInd = async function (id) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArticulosInd.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArticulosInd.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.updateArticulo = async function (id, serie, marca, modelo, observaciones, idCategoria,
  categoria, idSubcategoria, subcategoria, idArtBase, tag, direccionIP, macAddressW, macAddressE,
  ordenCompra, fechaCompra, finishGarantia, garantia, precioUnitario, idSAP, telefono, partida, noParte, localizacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('serie', serie)
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('observaciones', observaciones)
  formData.append('idCategoria', idCategoria)
  formData.append('categoria', categoria)
  formData.append('idSubcategoria', idSubcategoria)
  formData.append('subcategoria', subcategoria)
  formData.append('idArtBase', idArtBase)
  formData.append('tag', tag)
  formData.append('direccionIP', direccionIP)
  formData.append('macAddressW', macAddressW)
  formData.append('macAddressE', macAddressE)
  formData.append('ordenCompra', ordenCompra)
  formData.append('observaciones', observaciones)
  formData.append('fechaCompra', fechaCompra)
  formData.append('finishGarantia', finishGarantia)
  formData.append('garantia', garantia)
  formData.append('precioUnitario', precioUnitario)
  formData.append('idSAP', idSAP)
  formData.append('telefono', telefono)
  formData.append('partida', partida)
  formData.append('noParte', noParte)
  formData.append('localizacion', localizacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editArticulo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.updateMaquinaria = async function (id, serie, marca, modelo, observaciones, idCategoria, categoria, idSubcategoria, subcategoria, idArtBase, tag, direccionIP, macAddressW, macAddressE, ordenCompra, fechaCompra, finishGarantia, garantia, precioUnitario, idSAP, ubicacion, oficina) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('serie', serie)
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('observaciones', observaciones)
  formData.append('idCategoria', idCategoria)
  formData.append('categoria', categoria)
  formData.append('idSubcategoria', idSubcategoria)
  formData.append('subcategoria', subcategoria)
  formData.append('idArtBase', idArtBase)
  formData.append('tag', tag)
  formData.append('direccionIP', direccionIP)
  formData.append('macAddressW', macAddressW)
  formData.append('macAddressE', macAddressE)
  formData.append('ordenCompra', ordenCompra)
  formData.append('observaciones', observaciones)
  formData.append('fechaCompra', fechaCompra)
  formData.append('finishGarantia', finishGarantia)
  formData.append('garantia', garantia)
  formData.append('precioUnitario', precioUnitario)
  formData.append('idSAP', idSAP)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editMaquinaria.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.updateCambios = async function (idUsuario, idArticulo, fecha, cambios) {
  let formData = new FormData()
  formData.append('idU', idUsuario)
  formData.append('idA', idArticulo)
  formData.append('f', fecha)
  formData.append('c', cambios)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addUpdates.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.update_AddConsumible = async function (id, ubicacion, oficina, ordenCompra, fechaCompra, cantidadNueva) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)
  formData.append('ordenCompra', ordenCompra)
  formData.append('fechaCompra', fechaCompra)
  formData.append('cantidad', cantidadNueva)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editArticulo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.countAltas = function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/inventario/countAltas.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/inventario/countAltas.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

InventarioServices.addAlta = function (id, fecha, idUsuario, usuario, ubicacion, idSolicita, uSolicita, idAutoriza, uAutoriza, area) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fecha', fecha)
  formData.append('idUsuario', idUsuario)
  formData.append('usuario', usuario)
  formData.append('ubicacion', ubicacion)
  formData.append('idSolicita', idSolicita)
  formData.append('uSolicita', uSolicita)
  formData.append('idAutoriza', idAutoriza)
  formData.append('uAutoriza', uAutoriza)
  formData.append('area', area)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addAlta.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

InventarioServices.editAlta = function (id, ubicacion, idSolicita, uSolicita, idAutoriza, uAutoriza, area, ordenCompra, tipo) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ubicacion', ubicacion)
  formData.append('idSolicita', idSolicita)
  formData.append('uSolicita', uSolicita)
  formData.append('idAutoriza', idAutoriza)
  formData.append('uAutoriza', uAutoriza)
  formData.append('area', area)
  formData.append('ordenCompra', ordenCompra)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editAlta.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

InventarioServices.getAltaInd = function (idAlta) {
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/inventario/getAltaInd.php?id=${idAlta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/inventario/getAltaInd.php?id=${idAlta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

InventarioServices.getItems = async function (id) {
  let formData = new FormData()
  formData.append('idAlta', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getItems.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.deleteItem = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteItem.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}
// Esta No esta
InventarioServices.updateItem = async function (id, serie, marca, modelo, observaciones, estado, idCat, categoria, id_subCat, subCat, oficina, ordenCompra) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('serie', serie)
  formData.append('marca', marca)
  formData.append('modelo', modelo)
  formData.append('observaciones', observaciones)
  formData.append('idCat', idCat)
  formData.append('categoria', categoria)
  formData.append('id_subCat', id_subCat)
  formData.append('subCat', subCat)
  formData.append('oficina', oficina)
  formData.append('ordenCompra', ordenCompra)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateItem.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getSalidas = function () {
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get('/servidores/inventario/getSalidas.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get('/servidores/inventario/getSalidas.php')
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

InventarioServices.getSalidas_Fecha = async function (fecha) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getSalidas_Fecha.php?f=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getSalidas_Fecha.php?f=${fecha}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getAsignacion_Fecha = async function (fecha) {
  let formData = new FormData()
  formData.append('f', fecha)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getAsignacion_Fecha.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getSalidas_Usuario = async function (id, tipo) {
  let formData = new FormData()
  formData.append('i', id)
  formData.append('t', tipo)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getSalidas_Usuario.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignacion_Usuario = async function (id, tipo) {

  let formData = new FormData()
  formData.append('i', id)
  formData.append('t', tipo)
  
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getAsignacion_Usuario.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getSalidas_Ubicacion = async function (ubi) {
  let formData = new FormData()
  formData.append('u', ubi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getSalidas_Ubicacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignacion_Ubicacion = async function (ubi) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getAsignacion_Ubicacion.php?u=${ubi}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getAsignacion_Ubicacion.php?u=${ubi}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getAsignacion_Almacen = async function (alm) {
  let formData = new FormData()
  formData.append('u', alm)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getAsignacion_Almacen.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosAsig_Ubicacion = async function (ubi) {
  let formData = new FormData()
  formData.append('u', ubi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getArt_AsigAsignados_Ubicacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosOficina = async function (ofi) {
  let formData = new FormData()
  formData.append('o', ofi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getArticulosOficina.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
  
}

InventarioServices.addSalida = async function (id, fecha, idEntrega, entrega, idUTraslada, traslada, idRecibe,
  recibe, idAutoriza, autoriza, origen, destino, ofi_origen, ofi_dest, area, hash) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fecha', fecha)
  formData.append('idEntrega', idEntrega)
  formData.append('entrega', entrega)
  formData.append('idUTraslada', idUTraslada)
  formData.append('traslada', traslada)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('idAutoriza', idAutoriza)
  formData.append('autoriza', autoriza)
  formData.append('origen', origen)
  formData.append('destino', destino)
  formData.append('ofiOrigen', ofi_origen)
  formData.append('ofiDest', ofi_dest)
  formData.append('area', area)
  formData.append('hash', hash)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addSalida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.countSalidas = async function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/countSalidas.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/countSalidas.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSalidaInd = async function (id) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getSalidaInd.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.editSalida = async function (id, idTraslada, traslada, idRecibe, recibe, idAutoriza, autoriza, destino, oficina, area) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idTraslada', idTraslada)
  formData.append('traslada', traslada)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('idAutoriza', idAutoriza)
  formData.append('autoriza', autoriza)
  formData.append('destino', destino)
  formData.append('oficina', oficina)
  formData.append('area', area)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editSalida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getItemsAutoComplete = async function (tipo, origen) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getItemsAuto.php?tipo=${tipo}&origen=${origen}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getItemsAuto.php?tipo=${tipo}&origen=${origen}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addItemToSalida = async function (id, idSalida, idUbi, idItem, serie) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idSalida', idSalida)
  formData.append('idUbi', idUbi)
  formData.append('idItem', idItem)
  formData.append('serie', serie)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addItem_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getItemsSalida = async function (id) {
  let formData = new FormData()
  formData.append('idSalida', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getItemsSalida.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getItemsCons_Salida = async function (id) {
  let formData = new FormData()
  formData.append('idS', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getItemsCons_Salida.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getItemsCons_Asignacion = async function (id) {
  let formData = new FormData()
  formData.append('idAsign', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getItemsCons_Asignacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.aceptarItemSalida = async function (idItem, estadoAct, aceptar) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('aceptar', aceptar)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/aceptarItemSalida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.aceptarItemCons_Salida = async function (idItem, cant, estado) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('cant', cant)
  formData.append('e', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/aceptarItemCons_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.aceptarItemCons_Asignaciones = async function (idItem, cant, estado) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('cant', cant)
  formData.append('e', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/aceptarItemCons_Asignaciones.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.updateObservacionItemCons_Salida = async function (idItem, observacion, estado) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('o', observacion)
  formData.append('e', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacionItemCons_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateObservacionItemCons_Asignaciones = async function (idItem, observacion, estado) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('o', observacion)
  formData.append('e', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacionItemCons_Asignaciones.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.aceptarItemAsignacion = async function (idItem, estadoAct, aceptar) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('aceptar', aceptar)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/aceptarItemAsignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.aceptarItemPrestamo = async function (idItem, estadoAct, aceptar) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('aceptar', aceptar)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/aceptarItemPrestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateObservacion = async function (idItem, estadoAct, observacion) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateObservacionCons = async function (idItem, estadoAct, observacion) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacionCons.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateObservacionIA = async function (idItem, estadoAct, observacion) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacionIA.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateObservacionPrestamo = async function (idItem, estadoAct, observacion) {
  let formData = new FormData()
  formData.append('idItem', idItem)
  formData.append('estadoAct', estadoAct)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/updateObservacionPrestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.FirmarSalida = async function (nombreSalida, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('nombreSalida', nombreSalida)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/firmarSalida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.FirmarCons_Salida = async function (idS, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('idS', idS)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/firmarCons_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.FirmarCons_Asignacion = async function (idA, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('idA', idA)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/firmarCons_Asignacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.FirmarAsignacion = async function (nombreAsignacion, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('nombreAsignacion', nombreAsignacion)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/firmarAsignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.firmarPrestamo = async function (idPrestamo, qFirma, firma, nombreFile) {
  let formData = new FormData()
  formData.append('idPrestamo', idPrestamo)
  formData.append('qFirma', qFirma)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/firmarPrestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getItemsAsignacion = async function (id) {
  let formData = new FormData()
  formData.append('i', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getItemsAsignacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getItemsPrestamo = async function (id) {
  let formData = new FormData()
  formData.append('i', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/prestamos/getItemsPrestamo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

// Ubicaciones
InventarioServices.addUbicacion = async function (id, idArt, fechaReg, ubicacion, oficina, id_entrega, entrega, id_recibe, recibe, tipo) {
  let formData = new FormData()

  formData.append('id', id)
  formData.append('idArt', idArt)
  formData.append('fechaReg', fechaReg)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)
  formData.append('id_entrega', id_entrega)
  formData.append('entrega', entrega)
  formData.append('id_recibe', id_recibe)
  formData.append('recibe', recibe)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addUbicacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateUbicacionArt = async function (idArt, newUbicacion, oficina, idResguardo, resguardo, ultimoMov) {
  let formData = new FormData()
  formData.append('idArt', idArt)
  formData.append('newUbicacion', newUbicacion)
  formData.append('oficina', oficina)
  formData.append('idResguardo', idResguardo)
  formData.append('resguardo', resguardo)
  formData.append('ultimoMov', ultimoMov)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateUbicacionArt.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateArticulo_ubi_salida = async function (idUbiArt, ubicacion, oficina, idRec, rec) {
  let formData = new FormData()
  formData.append('idUA', idUbiArt)
  formData.append('ubi', ubicacion)
  formData.append('of', oficina)
  formData.append('idRec', idRec)
  formData.append('rec', rec)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateArticulo_ubi_salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateArticulo_ubi_prestamo = async function (idUbiArt, ubicacion, oficina, idRec, rec) {
  let formData = new FormData()
  formData.append('idUA', idUbiArt)
  formData.append('ubi', ubicacion)
  formData.append('of', oficina)
  formData.append('idRec', idRec)
  formData.append('rec', rec)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/updateArticulo_ubi_prestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getUltimoMov = async function (idArt, ubicacion) {
  let formData = new FormData()
  formData.append('idArt', idArt)
  formData.append('ubicacion', ubicacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getUltimoMov.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.editRegUbicacion = async function (id, ubicacion, oficina) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editReg_Ubicacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteRegUbicacion = async function (idArt, ubicacion, tipo) {
  let formData = new FormData()
  formData.append('id', idArt)
  formData.append('ubicacion', ubicacion)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteReg_Ubicacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteItemToSalida = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteItem_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    return bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  } else {
    return bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
  }
}

InventarioServices.getAsignaciones = async function (ubicacion, cargo) {
  let formData = new FormData()
  formData.append('u', ubicacion)
  formData.append('c', cargo)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: 'servidores/inventario/getAsignaciones.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignacionesArea = async function (area) {

  let formData = new FormData()
  formData.append('a', area)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getAsignacionesArea.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignacionesSubArea = async function (area) {
  let formData = new FormData()
  formData.append('a', area)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getAsignacionesSubArea.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignaciones_User = async function (id) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getAsignaciones_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getAsignaciones_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getReingresos = async function (ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getReingresos.php?u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getReingresos.php?u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getReingresosArea = async function (area) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getReingresosArea.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getReingresosArea.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getReingresos_User = async function (id) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getReingresos_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getReingresos_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getPrestamos = async function (ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/prestamos/getPrestamos.php?u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/prestamos/getPrestamos.php?u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getPrestamosArea = async function (area) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/prestamos/getPrestamosArea.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/prestamos/getPrestamosArea.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getPrestamos_User = async function (id) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/prestamos/getPrestamos_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/prestamos/getPrestamos_User.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getOtrasAsignaciones_User = async function (idUser) {
  let formData = new FormData()
  formData.append('idU', idUser)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getOtrasAsignaciones_User.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getOtrasAsignaciones = async function (area_asignacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getOtrasAsignaciones.php?a=${area_asignacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getOtrasAsignaciones.php?a=${area_asignacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getOtrosEstados = async function (area) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getOtrosEstados.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getOtrosEstados.php?a=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.countAsignaciones = async function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/countAsignacion.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/countAsignacion.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .catch(e => console.log(e))
      .then(res => res.data)
    return data
  }
}

InventarioServices.countPrestamos = async function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/prestamos/countPrestamos.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/prestamos/countPrestamos.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .catch(e => console.log(e))
      .then(res => res.data)
    return data
  }
}

InventarioServices.addAsignacion = async function (id, fechaReg, idEntrega, entrega, idRecibe, recibe,
  area, origen, ubicacion, ofi_origen, ofi_destino, hash) {
  let formData = new FormData()
  formData.append('hash', hash)
  formData.append('fechaReg', fechaReg)
  formData.append('idEntrega', idEntrega)
  formData.append('entrega', entrega)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('area', area)
  formData.append('origen', origen)
  formData.append('ubicacion', ubicacion)
  formData.append('ofi_origen', ofi_origen)
  formData.append('oficina', ofi_destino)
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addAsignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.addPrestamo = async function (id, fechaReg, idEntrega, entrega, idRecibe, recibe, area,
  origen, ofi_origen, ubicacion, oficina, hash) {
  let formData = new FormData()
  formData.append('hash', hash)
  formData.append('fechaReg', fechaReg)
  formData.append('idEntrega', idEntrega)
  formData.append('entrega', entrega)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('area', area)
  formData.append('origen', origen)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)
  formData.append('ofi_origen', ofi_origen)
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/addPrestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.editAsignacion = async function (id, idRecibe, recibe, area, ubicacion, oficina) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('area', area)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/editAsignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.editPrestamo = async function (id, idRecibe, recibe, area, ubicacion, oficina) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idRecibe', idRecibe)
  formData.append('recibe', recibe)
  formData.append('area', area)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/editPrestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.getAsignacionInd = async function (id) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getAsignacionInd.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArt_for_Asign = async function (idUser) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getArt_Asig_User.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
  
}

InventarioServices.addItemToAsign = async function (id, idArt, idAsign, idUbiArt, serie) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idArt', idArt)
  formData.append('idAsign', idAsign)
  formData.append('idUbiArt', idUbiArt)
  formData.append('serie', serie)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addItem_Asignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.addItemToPrestamos = async function (idArt, idPrestamo, idUbiArt, serie, fechaEntrega) {
  let formData = new FormData()
  formData.append('idArt', idArt)
  formData.append('idPrestamo', idPrestamo)
  formData.append('idUbiArt', idUbiArt)
  formData.append('serie', serie)
  formData.append('fechaEntrega', fechaEntrega)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/addItem_Prestamo.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.getArtAsignados = async function (idAsig) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getArt_AsigAsignados.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArtSalida = async function (idAsig) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getArt_SalidaAsignados.php?id=${idAsig}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getArt_SalidaAsignados.php?id=${idAsig}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getArtPrestamo = async function (id) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/prestamos/getArt_Prestamo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.deleteItemToAsign = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteItem_Asignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.getHistoria = async function (id) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getHistoria.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getHistoriaNumero = async function (numero) {
  let formData = new FormData()
  formData.append('n', numero)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getHistoriaNumero.php'
  }
  
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getHistoriaCompra = async function (id) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getHistoriaCompra.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getHistoriaCompra.php?id=${id}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getResguardos = async function (id) {
  let formData = new FormData()
  formData.append('id', id)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getResguardos.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.createExcel_ubicacion = async function (ubicacion, title) {
  let formData = new FormData()
  formData.append('ubicacion', ubicacion)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/Inventario_ubicacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.createExcel_ubicacionSede = async function (ubicacion, title) {
  let formData = new FormData()
  formData.append('ubicacion', ubicacion)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/Inventario_ubicacionSede.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.createExcel_consumibles = async function (ubicacion, title) {
  let formData = new FormData()
  formData.append('ubicacion', ubicacion)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/Inventario_Consumibles.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.createExcel_consumiblesSedes = async function (ubicacion, title) {
  let formData = new FormData()
  formData.append('ubicacion', ubicacion)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/DescargarConsumiblesSede.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.createExcel_Usuario = async function (idUsuario, usuario, title) {
  let formData = new FormData()
  formData.append('idUsuario', idUsuario)
  formData.append('usuario', usuario)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/Inventario_Usuario.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.createExcel_Resguardo_Usuario = async function (idResguarda, resguarda, title) {
  let formData = new FormData()
  formData.append('idResguarda', idResguarda)
  formData.append('resguarda', resguarda)
  formData.append('title', title)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/Resguardos_Usuario.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.createExcel_Resguardos = async function (ubi, cargo, area, subarea) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/reportesApp/server/excel/ResguardosArea.php?ubi=${ubi}&c=${cargo}&a=${area}&sa=${subarea}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/reportesApp/server/excel/ResguardosArea.php?ubi=${ubi}&c=${cargo}&a=${area}&sa=${subarea}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.createExcel_Activos = async function () {
  const data = await bdServices.get(`/reportesApp/server/excel/createExcel_Activos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}


InventarioServices.descargarAsignaciones = async function (irge, tpa, ducto, corpo, inst, sist, transp, comunic, mob, tags, siVale, herr, allSedes, allAreas) {
  let formData = new FormData()
  formData.append('irge', irge)
  formData.append('tpa', tpa)
  formData.append('ducto', ducto)
  formData.append('corpo', corpo)
  formData.append('inst', inst)
  formData.append('sist', sist)
  formData.append('transp', transp)
  formData.append('comunic', comunic)
  formData.append('mob', mob)
  formData.append('tags', tags)
  formData.append('siVale', siVale)
  formData.append('herr', herr)
  formData.append('allSedes', allSedes)
  formData.append('allAreas', allAreas)


  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/descargarAsignaciones.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.descargarAsignacionesSede = async function (ubi) {
  let formData = new FormData()
  formData.append('ubi', ubi)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/descargarAsignacionesSede.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.descargarMaquinaria = async function (ubi) {
  const data = await bdServices.get(`/reportesApp/server/excel/descargarMaq.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.createExcel_Resguardo_Otros = async function (ubi) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/reportesApp/server/excel/Resguardos_Otros.php?ubi=${ubi}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/reportesApp/server/excel/Resguardos_Otros.php?ubi=${ubi}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.borrarFile_InventarioUser = async function (nameFile) {
  const data = await bdServices.get(`/reportesApp/server/excel/borrarInventario_User.php?nameFile=${nameFile}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.borrarInventario_Ubicacion = async function (nameFile) {
  const data = await bdServices.get(`/reportesApp/server/excel/borrarInventario_Ubicacion.php?nameFile=${nameFile}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.borrarFile_ResguardoUser = async function (nameFile) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/reportesApp/server/excel/borrarResguardo_User.php?nameFile=${nameFile}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/reportesApp/server/excel/borrarResguardo_User.php?nameFile=${nameFile}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addSolicitud = async function (fechaReg, equipo, id_categoria, categoria, id_subcategoria, subcategoria, razon, cantidad, ubicacion, area, departamento, oficina, idSolicita, solicita, prioridad, servicio, estado) {
  let formData = new FormData()
  formData.append('fechaReg', fechaReg)
  formData.append('equipo', equipo)
  formData.append('id_categoria', id_categoria)
  formData.append('categoria', categoria)
  formData.append('id_subcategoria', id_subcategoria)
  formData.append('subcategoria', subcategoria)
  formData.append('razon', razon)
  formData.append('cantidad', cantidad)
  formData.append('ubicacion', ubicacion)
  formData.append('area', area)
  formData.append('departamento', departamento)
  formData.append('oficina', oficina)
  formData.append('idSolicita', idSolicita)
  formData.append('solicita', solicita)
  formData.append('prioridad', prioridad)
  formData.append('servicio', servicio)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/solicitudes/addSolicitud.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.getSolicitudes_All = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_All.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_All.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSolicitudes_user = async function (id, limit) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_user.php?id=${id}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_user.php?id=${id}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSolicitudes_area = async function (area, limit) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_area.php?area=${area}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_area.php?area=${area}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSolicitudes_depto = async function (depto, limit) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_depto.php?depto=${depto}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_depto.php?depto=${depto}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSolicitudes_ubicacion = async function (ubicacion, limit) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_ubicacion.php?ubicacion=${ubicacion}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_ubicacion.php?ubicacion=${ubicacion}&limit=${limit}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSolicitudes_ducto = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/solicitudes/getSolicitudes_ducto.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/solicitudes/getSolicitudes_ducto.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.updateSolicitud_estado = async function (id, estado) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/solicitudes/updateSolicitud_estado.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getDataNoPresupuesta = async function (ubicacion, anio, mes) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getNoPresupuestada.php?u=${ubicacion}&m=${mes}&a=${anio}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getNoPresupuestada.php?u=${ubicacion}&m=${mes}&a=${anio}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getProveedores = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getProveedores.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getProveedores.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getProveedoresPendientes = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getProveedoresPendientes.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getProveedoresPendientes.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addProveedor = async function (nombre, rfc, tel1, tel2, tel3, ext, pais, estado, ciudad, colonia, calle, numExt, numInt, cp, contacto, correo, credito, cuenta, clabe, isN, idBanco, efectivo) {
  let formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('rfc', rfc)
  formData.append('tel1', tel1)
  formData.append('tel2', tel2)
  formData.append('tel3', tel3)
  formData.append('ext', ext)
  formData.append('pais', pais)
  formData.append('estado', estado)
  formData.append('ciudad', ciudad)
  formData.append('colonia', colonia)
  formData.append('calle', calle)
  formData.append('numExt', numExt)
  formData.append('numInt', numInt)
  formData.append('cp', cp)
  formData.append('contacto', contacto)
  formData.append('correo', correo)
  formData.append('credito', credito)
  formData.append('cuenta', cuenta)
  formData.append('clabe', clabe)
  formData.append('isN', isN)
  formData.append('idBanco', idBanco)
  formData.append('efectivo', efectivo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/addProveedor.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addNameProveedor = async function (nombre) {
  let formData = new FormData()
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/addNameProveedor.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.editProveedor = async function (idProv, nombre, rfc, tel1, tel2, tel3, ext, pais, estado, ciudad, colonia, calle, numExt, numInt, cp, contacto, correo, credito, cuenta, clabe, isN, idBanco, efectivo) {
  let formData = new FormData()
  formData.append('idProv', idProv)
  formData.append('nombre', nombre)
  formData.append('rfc', rfc)
  formData.append('tel1', tel1)
  formData.append('tel2', tel2)
  formData.append('tel3', tel3)
  formData.append('ext', ext)
  formData.append('pais', pais)
  formData.append('estado', estado)
  formData.append('ciudad', ciudad)
  formData.append('colonia', colonia)
  formData.append('calle', calle)
  formData.append('numExt', numExt)
  formData.append('numInt', numInt)
  formData.append('cp', cp)
  formData.append('contacto', contacto)
  formData.append('correo', correo)
  formData.append('credito', credito)
  formData.append('cuenta', cuenta)
  formData.append('clabe', clabe)
  formData.append('isN', isN)
  formData.append('idBanco', idBanco)
  formData.append('efectivo', efectivo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/editProveedor.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getIdRequisicion = async function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getRequisicion_Id.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getRequisicion_Id.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getRequisiciones = async function (id, tipo, periodo) {
  if (currentUrl === '10.121.40.125') {
    return bdServices125.get(`/servidores/inventario/requisiciones/getRequisiciones.php?id=${id}&tipo=${tipo}&p=${periodo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  } else {
    return bdServices.get(`/servidores/inventario/requisiciones/getRequisiciones.php?id=${id}&tipo=${tipo}&p=${periodo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
  }
}

InventarioServices.addRequisicion = async function (idReq, fechaReg, area, tipo, ubicacion, presupuestada, cantidadNP, partida, justificacion, cotizacion, moneda, subtotal, iva, total, totalStr, entrega, nombreBS, especificaciones, comentarios, incluye, condiciones, idProv1, monedaP1, totalP1, idProv2, monedaP2, totalP2, idProv3, monedaP3, totalP3, provSel, idUser, nombreUser, idUser_sol, user_sol, idUser_Plantel, user_gp, idUser_JA, user_ja, idUserRev, user_rev, idUser_aut, user_au) {
  let formData = new FormData()
  formData.append('idR', idReq)
  formData.append('f', fechaReg)
  formData.append('a', area)
  formData.append('t', tipo)
  formData.append('u', ubicacion)
  formData.append('p', presupuestada)
  formData.append('cNP', cantidadNP)
  formData.append('pa', partida)
  formData.append('j', justificacion)
  formData.append('cot', cotizacion)
  formData.append('m', moneda)
  formData.append('s', subtotal)
  formData.append('iva', iva)
  formData.append('tot', total)
  formData.append('totStr', totalStr)
  formData.append('ent', entrega)
  formData.append('nombreBS', nombreBS)
  formData.append('esp', especificaciones)
  formData.append('com', comentarios)
  formData.append('inc', incluye)
  formData.append('cond', condiciones)
  formData.append('ip1', idProv1)
  formData.append('mp1', monedaP1)
  formData.append('tp1', totalP1)
  formData.append('ip2', idProv2)
  formData.append('mp2', monedaP2)
  formData.append('tp2', totalP2)
  formData.append('ip3', idProv3)
  formData.append('mp3', monedaP3)
  formData.append('tp3', totalP3)
  formData.append('ips', provSel)
  formData.append('is', idUser_sol)
  formData.append('ip', idUser_Plantel)
  formData.append('iJA', idUser_JA)
  formData.append('iuR', idUserRev)
  formData.append('ia', idUser_aut)
  formData.append('user_sol', user_sol)
  formData.append('user_gp', user_gp)
  formData.append('user_ja', user_ja)
  formData.append('user_rev', user_rev)
  formData.append('user_au', user_au)
  formData.append('id_user', idUser)
  formData.append('n_user', nombreUser)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/addRequisicion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateRequisicion = async function (id, idReq, fechaReg, area, tipo, ubicacion, presupuestada, cantidadNP, partida, justificacion, cotizacion, moneda, subtotal, iva, total, totalStr, entrega, nombreBS, especificaciones, comentarios, incluye, condiciones, idProv1, monedaP1, totalP1, idProv2, monedaP2, totalP2, idProv3, monedaP3, totalP3, provSel, idUser_sol, user_sol, idUser_Plantel, user_gp, idUser_JA, user_ja, idUserRev, user_rev, idUser_aut, user_au) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idR', idReq)
  formData.append('f', fechaReg)
  formData.append('a', area)
  formData.append('t', tipo)
  formData.append('u', ubicacion)
  formData.append('p', presupuestada)
  formData.append('cNP', cantidadNP)
  formData.append('pa', partida)
  formData.append('j', justificacion)
  formData.append('cot', cotizacion)
  formData.append('m', moneda)
  formData.append('s', subtotal)
  formData.append('iva', iva)
  formData.append('tot', total)
  formData.append('totStr', totalStr)
  formData.append('ent', entrega)
  formData.append('nombreBS', nombreBS)
  formData.append('esp', especificaciones)
  formData.append('com', comentarios)
  formData.append('inc', incluye)
  formData.append('cond', condiciones)
  formData.append('ip1', idProv1)
  formData.append('mp1', monedaP1)
  formData.append('tp1', totalP1)
  formData.append('ip2', idProv2)
  formData.append('mp2', monedaP2)
  formData.append('tp2', totalP2)
  formData.append('ip3', idProv3)
  formData.append('mp3', monedaP3)
  formData.append('tp3', totalP3)
  formData.append('ips', provSel)
  formData.append('is', idUser_sol)
  formData.append('ip', idUser_Plantel)
  formData.append('iJA', idUser_JA)
  formData.append('iuR', idUserRev)
  formData.append('ia', idUser_aut)
  formData.append('user_sol', user_sol)
  formData.append('user_gp', user_gp)
  formData.append('user_ja', user_ja)
  formData.append('user_rev', user_rev)
  formData.append('user_au', user_au)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/updateRequisicion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}


InventarioServices.addRequisicion_Item = async function (idRequisicion, idBaseArt, idTicket, cant, uM, pU, importe, tipo) {
  let formData = new FormData()
  formData.append('idR', idRequisicion)
  formData.append('idBA', idBaseArt)
  formData.append('idT', idTicket)
  formData.append('cant', cant)
  formData.append('uM', uM)
  formData.append('pU', pU)
  formData.append('imp', importe)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/addRequisicion_Item.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.firmarRequisicion = async function (id, firma, nombreFile, estado) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/firmarRequisicion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addCotizacion = async function (idRequisicion, idUsuario, usuario, file, nombreFile) {
  let formData = new FormData()
  formData.append('iU', idUsuario)
  formData.append('u', usuario)
  formData.append('iR', idRequisicion)
  formData.append('nombreFile', nombreFile)
  formData.append('file', file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/addCotizacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateCotizacion = async function (idRequisicion, idUsuario, usuario, nombreFile, idCot, oldCot, file) {
  let formData = new FormData()
  formData.append('iU', idUsuario)
  formData.append('u', usuario)
  formData.append('iR', idRequisicion)
  formData.append('nombreFile', nombreFile)
  formData.append('old', oldCot)
  formData.append('iC', idCot)
  formData.append('file', file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/requisiciones/updateCotizacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getItems_Requisiciones = async function (idReq) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getItems_Requisiciones.php?id=${idReq}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getItems_Requisiciones.php?id=${idReq}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getRequisiciones_Ubicaciones = async function (ubicacion, estado) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getRequisiciones_Ubicacion.php?u=${ubicacion}&e=${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getRequisiciones_Ubicacion.php?u=${ubicacion}&e=${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getRequisiciones_Area = async function (area, estado) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getRequisiciones_Area.php?a=${area}&e=${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getRequisiciones_Area.php?a=${area}&e=${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getItemsPresupuesto = async function (tipo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getItemsPresupuesto.php?tipo=${tipo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getItemsPresupuesto.php?tipo=${tipo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getCotizaciones = async function (idRequisicion) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/requisiciones/getCotizaciones_Req.php?iR=${idRequisicion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/requisiciones/getCotizaciones_Req.php?iR=${idRequisicion}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getIdReasignacion = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getIdReasignacion.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getIdReasignacion.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addReasignacion = async function (id, fechaReg, idRealiza, nRealiza, idNuevo, nNuevo, area, ubicacion, oficina) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fR', fechaReg)
  formData.append('iR', idRealiza)
  formData.append('nR', nRealiza)
  formData.append('iN', idNuevo)
  formData.append('nN', nNuevo)
  formData.append('a', area)
  formData.append('u', ubicacion)
  formData.append('o', oficina)


  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/addReasignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateItems_Reasignacion = async function (idArticulo, idReasignacion, serie, idResguardo, nResguarda, idRealiza, nRealiza, ubicacion, oficina, idMov, fechaReg) {
  let formData = new FormData()
  formData.append('idA', idArticulo)
  formData.append('idR', idReasignacion)
  formData.append('s', serie)
  formData.append('idRes', idResguardo)
  formData.append('nRes', nResguarda)
  formData.append('idRea', idRealiza)
  formData.append('nRea', nRealiza)
  formData.append('u', ubicacion)
  formData.append('o', oficina)
  formData.append('idM', idMov)
  formData.append('fR', fechaReg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/updateItems_Reasignacion.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}


InventarioServices.getIdSalidaConsumible = async function (fechaI, fechaF) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getIdSalidaConsumible.php?fechaI=${fechaI}&fechaF${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = bdServices.get(`/servidores/inventario/getIdSalidaConsumible.php?fechaI=${fechaI}&fechaF${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}


InventarioServices.addConsumibleSalida = async function (fecha, fechaReg, origen, destino, id_entrega, entrega, id_trans, transporta, id_recibe, recibe) {
  let formData = new FormData()
  formData.append('f', fecha)
  formData.append('freg', fechaReg)
  formData.append('ori', origen)
  formData.append('dest', destino)
  formData.append('i_e', id_entrega)
  formData.append('u_e', entrega)
  formData.append('i_t', id_trans)
  formData.append('u_t', transporta)
  formData.append('i_r', id_recibe)
  formData.append('u_r', recibe)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addConsumibleAsignacion = async function (fecha, fechaReg, origen, destino, id_entrega, entrega, id_recibe, recibe) {
  let formData = new FormData()
  formData.append('f', fecha)
  formData.append('freg', fechaReg)
  formData.append('ori', origen)
  formData.append('dest', destino)
  formData.append('i_e', id_entrega)
  formData.append('u_e', entrega)
  formData.append('i_r', id_recibe)
  formData.append('u_r', recibe)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_asignacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.addConsumibleBack = async function (fechaReg, idconsumible, idExit, cantidad, origen, ubicacion, oficina, id_entrega, entrega, id_recibe, recibe) {
  let formData = new FormData()
  formData.append('freg', fechaReg)
  formData.append('idC', idconsumible)
  formData.append('idE', idExit)
  formData.append('cant', cantidad)
  formData.append('ori', origen)
  formData.append('ubi', ubicacion)
  formData.append('of', oficina)
  formData.append('i_e', id_entrega)
  formData.append('u_e', entrega)
  formData.append('i_r', id_recibe)
  formData.append('u_r', recibe)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/addConsumibleBack.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.add_consumible_exit = async function (idconsumible, idSalida, origen, destino, cantidad) {
  let formData = new FormData()
  formData.append('idc', idconsumible)
  formData.append('ids', idSalida)
  formData.append('dest', destino)
  formData.append('origen', origen)
  formData.append('cant', cantidad)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_exit.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.add_consumible_asign = async function (idconsumible, idasign, origen, destino, cantidad) {
  let formData = new FormData()
  formData.append('idc', idconsumible)
  formData.append('idasign', idasign)
  formData.append('dest', destino)
  formData.append('origen', origen)
  formData.append('cant', cantidad)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/add_consumible_asign.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getUsuarios_SalidasCons = async function (ubi) {
  let formData = new FormData()
  formData.append('ubi', ubi)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/getUsuarios_SalidasCons.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getItems_User_SalidasCons = async function (idUser) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/getItems_User_SalidasCons.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/getItems_User_SalidasCons.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.deleteTraslado = async function (id) {
  let formData = new FormData()
  formData.append('i', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/deleteTraslado.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}


InventarioServices.getTarjetas = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_user = async function (idUser) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_user.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_user.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getVehiculos = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getVehiculos.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getVehiculos.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getVehiculos_user = async function (idUser) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getVehiculos_user.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getVehiculos_user.php?id=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getStatusTarjetas = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getStatusTarjetas.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getStatusTarjetas.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getVehiculoWithData = async function (id_articulo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getVehiculoWithData.php?id=${id_articulo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getVehiculoWithData.php?id=${id_articulo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addVehiculoData = async function (id_articulo, placas, proxServ, verificacion, tipo,
  modelo, anio, tipoVerificacion) {
  let formData = new FormData()
  formData.append('id_articulo', id_articulo)
  formData.append('placas', placas)
  formData.append('proxServ', proxServ)
  formData.append('verificacion', verificacion)
  formData.append('tipo', tipo)
  formData.append('modelo', modelo)
  formData.append('anio', anio)
  formData.append('tipoV', tipoVerificacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addVehiculoData.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateVehiculoData = async function (id, proxServ, verificacion, anio, tipoVerificacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('proxServ', proxServ)
  formData.append('verificacion', verificacion)
  formData.append('anio', anio)
  formData.append('tipoV', tipoVerificacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/updateVehiculoData.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getMovimientos_UPTV = async function (idUser, periodo, idTarjeta) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getMovimientos_UPTV.php?uID=${idUser}&p=${periodo}&idT=${idTarjeta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getMovimientos_UPTV.php?uID=${idUser}&p=${periodo}&idT=${idTarjeta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addComb_AsignacionMensual = async function (f, fMov, p, ubi, area, idE, ent, idRec, rec, idA, noT, cantidad, extra) {
  let formData = new FormData()
  formData.append('f', f)
  formData.append('fMov', fMov)
  formData.append('p', p)
  formData.append('ubi', ubi)
  formData.append('area', area)
  formData.append('idE', idE)
  formData.append('ent', ent)
  formData.append('idRec', idRec)
  formData.append('rec', rec)
  formData.append('idA', idA)
  formData.append('noT', noT)
  formData.append('c', cantidad)
  formData.append('e', extra)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addComb_AsignacionMensual.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addComb_Traspaso = async function (f, fMov, p, ubi, area, idE, ent, idRec, rec, idTE, noTE, idTR, noTR, c) {
  let formData = new FormData()
  console.log(idTE)
  console.log(idTR)
  formData.append('f', f)
  formData.append('fMov', fMov)
  formData.append('p', p)
  formData.append('ubi', ubi)
  formData.append('area', area)
  formData.append('idE', idE)
  formData.append('ent', ent)
  formData.append('idRec', idRec)
  formData.append('rec', rec)
  formData.append('idTE', idTE)
  formData.append('noTE', noTE)
  formData.append('idTR', idTR)
  formData.append('noTR', noTR)
  formData.append('c', c)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addComb_Traspaso.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addComb_Salida = async function (fR, fS, p, ubi, area, idV, idT, idUser, nUser, cP, cL, kmA, obs, file) {
  let formData = new FormData()
  formData.append('fR', fR)
  formData.append('fS', fS)
  formData.append('p', p)
  formData.append('ubi', ubi)
  formData.append('area', area)
  formData.append('idV', idV)
  formData.append('idT', idT)
  formData.append('idUser', idUser)
  formData.append('nUser', nUser)
  formData.append('cP', cP)
  formData.append('cL', cL)
  formData.append('kmA', kmA)
  formData.append('obs', obs)
  formData.append('file', file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addComb_Salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteComb_salida = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/deleteComb_salida.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteComb_traspaso = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/deleteComb_traspaso.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteAsign_Combustible = async function (id, extra) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('extra', extra)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/deleteAsign_Combustible.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.editarSalidaComb = async function (id, fechaSalida, cargaP, cargaL, kmActual, idTarjeta, idVehiculo) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('fS', fechaSalida)
  formData.append('cP', cargaP)
  formData.append('cL', cargaL)
  formData.append('kA', kmActual)
  formData.append('iT', idTarjeta)
  formData.append('iV', idVehiculo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/editarSalidaComb.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.updateCierreMes = async function (fR, fS, p, idV, idT, idUser, nUser, kmA) {
  let formData = new FormData()
  formData.append('fR', fR)
  formData.append('fS', fS)
  formData.append('p', p)
  formData.append('idV', idV)
  formData.append('idT', idT)
  formData.append('idUser', idUser)
  formData.append('nUser', nUser)
  formData.append('kmA', kmA)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addComb_CierreMes.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addReporteMensual = async function (fR, p, idT, idV, idUser, nUser, ubi, area, idR, reviso, idA, autorizo, impTot, kmTot, litrosCons, prom, cal) {
  let formData = new FormData()
  formData.append('fR', fR)
  formData.append('p', p)
  formData.append('idT', idT)
  formData.append('idV', idV)
  formData.append('idUser', idUser)
  formData.append('nUser', nUser)
  formData.append('ubi', ubi)
  formData.append('area', area)
  formData.append('idR', idR)
  formData.append('reviso', reviso)
  formData.append('idA', idA)
  formData.append('autorizo', autorizo)
  formData.append('impTot', impTot)
  formData.append('kmTot', kmTot)
  formData.append('lCons', litrosCons)
  formData.append('prom', prom)
  formData.append('cal', cal)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addReporteMensual.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getComb_Asignaciones = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getComb_Asignaciones.php?periodo=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getComb_Asignaciones.php?periodo=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getComb_AsignacionesExtras = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getComb_AsignacionesExtras.php?periodo=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getComb_AsignacionesExtras.php?periodo=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getComb_Salidas = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getComb_Salidas.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getComb_Salidas.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getComb_Traspasos = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getComb_Traspasos.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getComb_Traspasos.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getComb_Asignaciones_Usuario = async function (idUser) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getComb_Asignaciones_Usuario.php?i=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getComb_Asignaciones_Usuario.php?i=${idUser}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getResumenes = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getResumenes.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getResumenes.php?p=${periodo}&ubi=${ubicacion}&cargo=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getResumenes_Ubicacion = async function (ubicacion, area) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getResumenes_Ubicacion.php?ubi=${ubicacion}&area=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getResumenes_Ubicacion.php?ubi=${ubicacion}&area=${area}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getResumenesData = async function (idUser, periodo, idTarjeta) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getResumenesData.php?uID=${idUser}&p=${periodo}&idT=${idTarjeta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getResumenesData.php?uID=${idUser}&p=${periodo}&idT=${idTarjeta}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getMovimientos_User_Periodo = async function (idUser, periodo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getMovimientos_User_Periodo.php?uID=${idUser}&periodo=${periodo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getMovimientos_User_Periodo.php?uID=${idUser}&periodo=${periodo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.FirmarResumen = async function (id, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/firmarResumen.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getFirmasPendientes_Comb = async function (uID, estado) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getFirmasPendientes_Comb.php?uID=${uID}&estado${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getFirmasPendientes_Comb.php?uID=${uID}&estado=${estado}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getSaldo = async function (idCard) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getSaldo.php?idCard=${idCard}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getSaldo.php?idCard=${idCard}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.subirTicket = async function (id, ticket) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ticket', ticket)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/subirTicket.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.subirFotoKm = async function (id, foto) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('foto', foto)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/subirFotoKm.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.uploadFichaTecnica = async function (id, nombreFile, file) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('file', file)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/uploadFichaTecnica.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.uploadFactura = async function (id, nombreFile, file) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('file', file)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/uploadFactura.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.uploadDocumento = async function (idArticulo, nombreFile, file, tipo) {
  let formData = new FormData()
  formData.append('id', idArticulo)
  formData.append('file', file)
  formData.append('nombreFile', nombreFile)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/uploadDocumento.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.subirFactura = async function (idArticulo, nombreFile, file) {
  let formData = new FormData()
  formData.append('id', idArticulo)
  formData.append('file', file)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/uploadFactura.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.deleteDocumento = async function (id, ruta) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ruta', ruta)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/deleteDocumento.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.deleteFactura = async function (id, ruta) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('ruta', ruta)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/documentos/deleteFactura.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.getSerie_exist = async function (serie) {
  let formData = new FormData()
  formData.append('s', serie)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getSerie_exist.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}


InventarioServices.getKmInicio = async function (idVehiculo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getKmInicio.php?idV=${idVehiculo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getKmInicio.php?idV=${idVehiculo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getVehiculosData = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getVehiculosData.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getVehiculosData.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_Movimientos = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_Movimientos.php?p=${periodo}&u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_Movimientos.php?p=${periodo}&u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_All = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_All.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_All.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_Respuestas = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_Respuestas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_Respuestas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_Comercios = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_Comercios.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_Comercios.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTarjetas_Afiliados = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetas_Afiliados.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetas_Afiliados.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.guardarAfiliado = async function (nombre) {
  let formData = new FormData()
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/addTAfiliado_Tarjeta.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.addTarjeta_Movimiento = function (id_tarjeta, placa, fecha, periodo, transaccion, abono, cargo, afiliado,
  kmAnterior, kmActual, kmRecorridos, comprobante, mercancia, cantidad_mercancia, precioUnitario, saldoAnt, saldoActual) {
  let formData = new FormData()
  formData.append('id_tarjeta', id_tarjeta)
  formData.append('placa', placa)
  formData.append('periodo', periodo)
  formData.append('fecha', fecha)
  formData.append('transaccion', transaccion)
  formData.append('abono', abono)
  formData.append('cargo', cargo)
  formData.append('afiliado', afiliado)
  formData.append('kmAnterior', kmAnterior)
  formData.append('kmActual', kmActual)
  formData.append('kmRecorridos', kmRecorridos)
  formData.append('comprobante', comprobante)
  formData.append('mercancia', mercancia)
  formData.append('cantidad_mercancia', cantidad_mercancia)
  formData.append('precioUnitario', precioUnitario)
  formData.append('saldoAnt', saldoAnt)
  formData.append('saldoActual', saldoActual)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tarjeta_Movimiento_add.php'
  }
  const data = bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.getTags_Movimientos = async function (periodo, ubicacion, cargo) {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTag_Movimientos.php?p=${periodo}&u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTag_Movimientos.php?p=${periodo}&u=${ubicacion}&c=${cargo}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTags_All = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTagAll.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTagAll.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.getTags_Cruces = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTag_Cruces.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTag_Cruces.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addTag_Movimiento = async function (id_tag, fecha, periodo, cargo, abono, transaccion, clase, id_cruce) {
  let formData = new FormData()
  formData.append('id_tag', id_tag)
  formData.append('fecha', fecha)
  formData.append('periodo', periodo)
  formData.append('cargo', cargo)
  formData.append('abono', abono)
  formData.append('transaccion', transaccion)
  formData.append('clase', clase)
  formData.append('id_cruce', id_cruce)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tag_Movimiento_add.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getTarjetas_Cargas = async function () {
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`/servidores/inventario/combustibles/getTarjetasCargas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`/servidores/inventario/combustibles/getTarjetasCargas.php`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

InventarioServices.addTarjeta_Comercio = async function (nombre) {
  let formData = new FormData()
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tarjeta_Comercio_add.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteTarjeta_Comercio = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tarjeta_Comercio_delete.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.addTag_Cruce = async function (nombre) {
  let formData = new FormData()
  formData.append('nombre', nombre)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tag_Cruce_add.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.deleteTag_Cruce = async function (id) {
  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/tag_Cruce_delete.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.getUbicaciones = async function () {
  const data = await bdServices.get(`/servidores/inventario/inventario/getUbicaciones.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAlmacenesConsumibles = async function (tipo) {
  const data = await bdServices.get(`/servidores/inventario/inventario/getAlmacenes2.php?t=${tipo}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getOficinas = async function () {
  const data = await bdServices.get(`/servidores/inventario/inventario/getOficinas.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getMaquinaria = async function () {
  const data = await bdServices.get(`/servidores/inventario/getMaquinaria.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.editarPlacas = async function (id, placas) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('placas', placas)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/actualizarPlacas.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.getAbonos = async function () {
  const data = await bdServices.get(`/servidores/inventario/combustibles/getAbonos.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getTraspasos = async function (fecha, ubi) {
  let formData = new FormData()
  formData.append('fecha', fecha)
  formData.append('ubi', ubi)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getTraspasos.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getTraspasosPendientes = async function (ubi) {
  const data = await bdServices.get(`/servidores/inventario/getTraspasosPendientes.php?ubi=${ubi}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getTraspasosCons = async function (fecha, ubi) {
  let formData = new FormData()
  formData.append('fecha', fecha)
  formData.append('ubi', ubi)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/getTraspasosCons.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getTraspasosConsPendientes = async function (ubi) {
  const data = await bdServices.get(`/servidores/inventario/getTraspasosConsPendientes.php?&ubi=${ubi}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAsignacionesPorCede = async function (alm) {
  const data = await bdServices.get(`/servidores/inventario/getAsignacionesPorCede.php?alm=${alm}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getPrestamosPorSede = async function (alm) {
  let formData = new FormData()
  formData.append('alm', alm)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/prestamos/getPrestamosPorSede.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getEstadosUso = async function () {
  const data = await bdServices.get(`/servidores/inventario/inventario/getEstadosUso.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.saveBaja = async function (claveBaja, fecha, fechaReg, id_articulo, idEntrega, entrega,
  idAutoriza, autoriza, origen, ofi_origen, ubicacion, oficina, hash, justificacion, area, activo) {
  let formData = new FormData()
  formData.append('claveBaja', claveBaja)
  formData.append('fecha', fecha)
  formData.append('fechaReg', fechaReg)
  formData.append('id_articulo', id_articulo)
  formData.append('idEntrega', idEntrega)
  formData.append('entrega', entrega)
  formData.append('idAutoriza', idAutoriza)
  formData.append('autoriza', autoriza)
  formData.append('origen', origen)
  formData.append('ofi_origen', ofi_origen)
  formData.append('ubicacion', ubicacion)
  formData.append('oficina', oficina)
  formData.append('hash', hash)
  formData.append('justificacion', justificacion)
  formData.append('area', area)
  formData.append('activo', activo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/bajas/addBaja.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.updateObservacionBaja = async function (id, observacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/bajas/updateObservacionBaja.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.updateObservacionArt = async function (id, observacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('observacion', observacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateObservacionArt.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.FirmarBaja = async function (idBaja, estadoAct, firma, nombreFile) {
  let formData = new FormData()
  formData.append('idBaja', idBaja)
  formData.append('estadoAct', estadoAct)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/bajas/firmarBaja.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }
}

InventarioServices.countBajas = async function (fechaI, fechaF) {
  const data = await bdServices.get(`/servidores/inventario/bajas/countBajas.php?fechaI=${fechaI}&fechaF=${fechaF}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getBajas = async function (ubi) {
  let formData = new FormData()
  formData.append('ubi', ubi)
  
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/bajas/getBajas.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticuloBaja = async function (id) {
  const data = await bdServices.get(`/servidores/inventario/bajas/getArticuloBaja.php?id=${id}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getPaginacionArticulos = async function (ubi) {
  let formData = new FormData()
  formData.append('ubi', ubi)
    
  const options = {
      method: 'POST',
      headers: { 'content-type': 'application/form-data' },
      data: formData,
      url: '/servidores/inventario/getPaginacionArticulos.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulos_Paginados = async function (ubi, offset, limit) {
  const data = await bdServices.get(`/servidores/inventario/getArticulos_Paginados.php?ubi=${ubi}&offset=${offset}&limit=${limit}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getMonedas = async function (ubi, offset, limit) {
  const data = await bdServices.get(`/servidores/inventario/getMonedas.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getAutomoviles = async function (idUsuario) {
  const data = await bdServices.get(`/servidores/inventario/combustibles/getVehiculos_user.php?id=${idUsuario}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.actualizarAutoEnTarjeta = async function (idTarjeta, idAutomovil) {
  let formData = new FormData()
  formData.append('idTarjeta', idTarjeta)
  formData.append('idAutomovil', idAutomovil)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/combustibles/updateAutoEnTarjeta.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.getTag = async function (tipo) {
  const data = await bdServices.get(`/servidores/inventario/getTag.php?tipo=${tipo}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.buscarArticuloBase = async function (marca, modelo, idCat, idSubCat) {
  const data = await bdServices.get(`/servidores/inventario/buscarArticuloBase.php?m=${marca}&mo=${modelo}&ic=${idCat}&is=${idSubCat}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.buscarConsumibleBase = async function (marca, modelo, idCat, idSubCat) {
  const data = await bdServices.get(`/servidores/inventario/buscarConsumibleBase.php?m=${marca}&mo=${modelo}&ic=${idCat}&is=${idSubCat}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getLocalizaciones = async function () {
  const data = await bdServices.get(`/servidores/inventario/getLocalizaciones.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.updateLocalizacion = async function (id, localizacion) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('localizacion', localizacion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateLocalizacion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.createExcel_TarjetasKilometros = async function (periodo) {
  let formData = new FormData()
  formData.append('periodo', periodo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: `/reportesApp/server/excel/tarjetas_kilometros.php?periodo=${periodo}`
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.obtenerIdTarjetas_Kilometros = async function (marca, modelo, idCat, idSubCat) {
  const data = await bdServices.get(`/servidores/inventario/combustibles/obtenerIdTarjetas_Kilometros.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.borrarImportacionTarjetas = async function (periodo) {
  let formData = new FormData()
  formData.append('periodo', periodo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: `/servidores/inventario/combustibles/tarjetasBorrarPeriodo.php?periodo=${periodo}`
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.getArticulosPartidaFactura = async function (partida) {
  const data = await bdServices.get(`/servidores/inventario/getArticulosPartidaFactura.php?partida=${partida}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

InventarioServices.getArticulosSerieModelo = async function (querie) {
  const data = await bdServices.get(`/servidores/inventario/getArticulosSerieModelo.php?querie=${querie}`)
  .then(res => res.data)
  .catch(e => console.log(e))
  return data
}

InventarioServices.addFactura = async function(factura, empresa, mes, area, partidaPresupuestal, ordenCompra, fechaFactura, serie, folio,
  UUID, idProveedor, RFC, moneda, monto, concepto, fechaPago, metodoPago) {
  let formData = new FormData()
  formData.append('factura', factura)
  formData.append('empresa', empresa)
  formData.append('mes', mes)
  formData.append('area', area)
  formData.append('partidaPresupuestal', partidaPresupuestal)
  formData.append('ordenCompra', ordenCompra)
  formData.append('fechaFactura', fechaFactura)
  formData.append('serie', serie)
  formData.append('folio', folio)
  formData.append('UUID', UUID)
  formData.append('idProveedor', idProveedor)
  formData.append('RFC', RFC)
  formData.append('moneda', moneda)
  formData.append('monto', monto)
  formData.append('concepto', concepto)
  formData.append('fechaPago', fechaPago)
  formData.append('metodoPago', metodoPago)
  
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/addFactura.php'
  }

  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125(options)
    .then(res => res.data)
    .catch((err) => {
        console.error(err)
      })
      return data
  } else {
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
  }

}

InventarioServices.getCompanias = async function () {
  const data = await bdServices.get('/servidores/inventario/getDivisiones.php')
  .then(res => res.data)
  .catch(e => console.log(e))
  return data
}

InventarioServices.changeCompania = async function (idArticulo, compania) {
  let formData = new FormData()
  formData.append('idArticulo', idArticulo)
  formData.append('compania', compania)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateCompania.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

InventarioServices.changeIdSAP = async function (idArticulo, idSAP) {
  let formData = new FormData()
  formData.append('idArticulo', idArticulo)
  formData.append('idSAP', idSAP)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/updateIdSAP.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

export default InventarioServices


// WEBPACK FOOTER //
// ./src/services/inventario/inventario.js